import React, { Component } from "react";
import {
  Typography,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Chip,
} from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, FormControl, Card } from "react-bootstrap";
import { PostData, DeleteData, PutData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import FileUpload from "../AddNew/FileUpload";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  REPORT_CATEGORIES,
  REPORT_UPLOAD_TYPE,
  getSubcategories,
  subLabel,
} from "./reportsMeta";

class ReportManager extends Component {
  state = {
    id: "",
    edit: false,
    category: this.props.lockedCategory || "",
    sub_category: "",
    title: "",
    date: "",
    description: "",
    upload_info: [],
    data: [],
    isDataLoaded: true,
    message: "",
    open: false,
    loadFile: true,
  };

  componentDidMount() {
    // When scoped to a fixed category (used as a per-category tab), load its list up front.
    if (this.props.lockedCategory) {
      this.__loadList();
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  // when the category dropdown changes, reset sub_category and reload the list
  onCategoryChange = (e) => {
    const category = e.target.value;
    this.setState({ category, sub_category: "" }, () => {
      this.__loadList();
    });
  };

  __loadList = () => {
    if (this.state.category === "") {
      this.setState({ data: [], isDataLoaded: true });
      return;
    }
    this.setState({ isDataLoaded: false });
    PostData(`/getreportsbycategory`, { category: this.state.category })
      .then((resp) => {
        this.setState({
          data: Array.isArray(resp) ? resp : [],
          isDataLoaded: true,
        });
      })
      .catch(() => {
        this.setState({ data: [], isDataLoaded: true });
      });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const d = {
      id: this.state.id,
      category: this.state.category,
      sub_category: this.state.sub_category,
      title: this.state.title,
      date: this.state.date,
      posted_as: "NSS Unit, Dispur College",
      description: this.state.description,
      upload_info: this.state.upload_info,
    };

    if (this.state.edit) {
      PutData(`/${this.props.apikey}/${this.state.id}/editreport`, d).then(
        (resp) => {
          this.setState({ message: resp, open: true }, () => this.__loadList());
          this.cancelEdit();
        }
      );
    } else {
      PostData(`/${this.props.apikey}/createreport`, d).then((resp) => {
        this.setState({ message: resp, open: true }, () => this.__loadList());
        this.cancelEdit();
      });
    }
  };

  onDeleteClick = (el) => {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete this report?",
      buttons: [
        { label: "Yes", onClick: this.onDeleteConfirm.bind(this, el.id) },
        { label: "No" },
      ],
    });
  };

  onDeleteConfirm = (id) => {
    DeleteData(`/${this.props.apikey}/${id}/deletereport`).then((resp) => {
      this.setState({ message: resp, open: true }, () => this.__loadList());
    });
  };

  onEditClick = (el) => {
    this.setState(
      {
        id: el.id,
        category: el.category,
        sub_category: el.sub_category,
        title: el.title,
        // backend returns date as dd-mm-yyyy; the <input type=date> needs yyyy-mm-dd
        date: this.__toInputDate(el.date),
        description: el.description || "",
        upload_info: Array.isArray(el.upload_info) ? el.upload_info : [],
        edit: true,
        loadFile: false,
      },
      () => this.setState({ loadFile: true })
    );
  };

  __toInputDate = (d) => {
    if (!d || typeof d !== "string") return "";
    const parts = d.split("-");
    if (parts.length === 3 && parts[0].length === 2) {
      // dd-mm-yyyy -> yyyy-mm-dd
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return d;
  };

  cancelEdit = () => {
    this.setState(
      {
        id: "",
        category: this.props.lockedCategory || "",
        sub_category: "",
        title: "",
        date: "",
        description: "",
        upload_info: [],
        edit: false,
        loadFile: false,
      },
      () => this.setState({ loadFile: true })
    );
  };

  render() {
    const subcategories = getSubcategories(this.state.category);

    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            message={this.state.message}
            handleClose={() => this.setState({ open: false, message: "" })}
          />
        ) : null}

        <form onSubmit={this.onSubmit}>
          <Typography variant="h6" gutterBottom>
            {this.props.title || "Information & Reports"}
          </Typography>

          <Card>
            <Card.Body>
              <Grid container spacing={2}>
                {!this.props.lockedCategory && (
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <label>Category</label>
                    <FormControl
                      as="select"
                      name="category"
                      required
                      value={this.state.category}
                      onChange={this.onCategoryChange}
                    >
                      <option value="">-- Select Category --</option>
                      {REPORT_CATEGORIES.map((c) => (
                        <option key={c.category} value={c.category}>
                          {c.title}
                        </option>
                      ))}
                    </FormControl>
                  </Grid>
                )}

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <label>Sub Category</label>
                  <FormControl
                    as="select"
                    name="sub_category"
                    required
                    value={this.state.sub_category}
                    onChange={this.onChange}
                    disabled={this.state.category === ""}
                  >
                    <option value="">-- Select Sub Category --</option>
                    {subcategories.map((s) => (
                      <option key={s.slug} value={s.slug}>
                        {s.label}
                      </option>
                    ))}
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <label>Date</label>
                  <FormControl
                    as="input"
                    type="date"
                    name="date"
                    required
                    onChange={this.onChange}
                    value={this.state.date}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={8} lg={8}>
                  <label>Title</label>
                  <FormControl
                    as="input"
                    name="title"
                    required
                    onChange={this.onChange}
                    value={this.state.title}
                    placeholder="Report title"
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <label>Description</label>
                  <ReactQuill
                    placeholder="Type something here"
                    value={this.state.description}
                    onChange={this.handleChange.bind(this, "description")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <label>Upload File(s) / Pictures</label>
                  {this.state.loadFile ? (
                    <FileUpload
                      dp={this.state.upload_info}
                      type={REPORT_UPLOAD_TYPE}
                      setDp={this.handleChange.bind(this, "upload_info")}
                    />
                  ) : null}
                </Grid>
              </Grid>

              {this.state.edit ? (
                <div align="right">
                  <Button size="sm" variant="danger" type="submit">
                    Update
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="secondary"
                    type="button"
                    onClick={this.cancelEdit}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                <div align="right">
                  <Button size="sm" variant="info" type="submit">
                    Submit
                  </Button>
                </div>
              )}
            </Card.Body>
          </Card>

          <br />

          <Card>
            <Card.Body>
              <Typography variant="subtitle1" gutterBottom>
                {this.state.category === ""
                  ? "Select a category to view its reports"
                  : "Reports in this category"}
              </Typography>

              {this.state.isDataLoaded ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell width="25%">Sub Category</TableCell>
                      <TableCell width="30%">Title</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Files</TableCell>
                      <TableCell>Edit</TableCell>
                      <TableCell>Delete</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.isArray(this.state.data) &&
                      this.state.data.map((el, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            {subLabel(el.category, el.sub_category)}
                          </TableCell>
                          <TableCell>{el.title}</TableCell>
                          <TableCell>{el.date}</TableCell>
                          <TableCell>
                            {Array.isArray(el.upload_info) &&
                              el.upload_info.map((el1, index1) => (
                                <Chip key={index1} label={el1.path} />
                              ))}
                          </TableCell>
                          <TableCell>
                            <Edit onClick={this.onEditClick.bind(this, el)} />
                          </TableCell>
                          <TableCell>
                            <Delete
                              onClick={this.onDeleteClick.bind(this, el)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>Loading . . .</Typography>
              )}
            </Card.Body>
          </Card>
        </form>
      </div>
    );
  }
}

export default ReportManager;
